import _ from 'lodash'
import swal from 'sweetalert2/dist/sweetalert2.min.js'
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
  methods: {
    // Helper function to confirm a delete action
    // Returns a promise with a boolean. Boolean is True if the action is confirmed
    confirmDeleteMessage(title, message, options = {}) {
      var msgBoxOptions = {
        title: title,
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel'
      }

      if(options.html) {
        msgBoxOptions.html = options.html
        msgBoxOptions.text = null
      }

      return swal.fire(msgBoxOptions).then((result) => {
        if(result.value)
          return Promise.resolve(result.value)
        return Promise.resolve(false)
      })
    },

    // Helper function to confirm an action
    // Returns a promise with a boolean. Boolean is True if the action is confirmed
    confirmMessage(title, message, options = {}) {
      var msgBoxOptions = {
        title: title,
        text: message,
        icon: options.icon || 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        width: options.width
      }

      if(options.html) {
        msgBoxOptions.html = options.html
        msgBoxOptions.text = null
      }

      return swal.fire(msgBoxOptions).then((result) => {
        if(result.value)
          return Promise.resolve(result.value)
        return Promise.resolve(false)
      })
    },

    // Custom message box passing the options directly to Sweet Alert 2
    // Returns a promise with results directly from Sweet Alert 2
    displayCustomMessageBox(title, message, sweetAlertConfig = {}) {
      var msgBoxOptions = _.defaults(sweetAlertConfig, {
        title: title,
        text: message,
        icon: 'warning'
      })

      return swal.fire(msgBoxOptions)
    },

    // Helper function to handle authentication error
    loggedOutMessage() {      
      return swal.fire({
        title: 'Logged out!',
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Login'
      }).then((result) => {
        if(result.value)
          return Promise.resolve(result.value)
        return Promise.resolve(false)
      })
    },

    warningToast(message = '', title = 'Warning') {
      var toastDetails = {
        title: title,
        text: message,
        position: 'top-end',
        icon: 'warning',
        customClass: {
          popup: 'synergy-toast',
        },
        showCloseButton: true,
        showConfirmButton: false,
        timer: 2000,
        toast: true
      }

      return swal.fire(toastDetails);
    },

    errorToast(message = '', title = 'Error') {
      var toastDetails = {
        title: title,
        text: message,
        position: 'top-end',
        icon: 'error',
        customClass: {
          popup: 'synergy-toast',
        },
        showCloseButton: true,
        showConfirmButton: false,
        timer: 2000,
        toast: true
      }

      return swal.fire(toastDetails);
    },

    successToast(message = '', title = 'Success') {
      var toastDetails = {
        title: title,
        text: message,
        position: 'top-end',
        icon: 'success',
        customClass: {
          popup: 'synergy-toast',
        },
        showCloseButton: true,
        showConfirmButton: false,
        timer: 5000,
        toast: true
      }
      return swal.fire(toastDetails);
    },

    successMessage(title, message) {
      return swal.fire({
        title: title,
        text: message,
        icon: 'success'
      });
    },

    warningMessage(title, message) {        
      return swal.fire({
        title: title,
        text: message,
        icon: 'warning'
      });
  },

    errorMessage(title, message) {
      return swal.fire({
        title: title,
        text: message,
        icon: 'error'
      });
    },

    displayNetworkError(response, title = 'Error', message = '') {
      var errorMsg = _.get(response, 'response.data.error.message')
      if(!errorMsg)
        errorMsg = 'Internal Network Error'

      if(response)
        console.error(response)

      message += '<br /><br />' + errorMsg

      return swal.fire({
        title: title,
        html: message,
        icon: 'error'
      });
    }
  }
}